__webpack_require__.p = "/extract-redactor-inserts-to-wysiwyg/onboarding/";